import { render, staticRenderFns } from "./searchCom.vue?vue&type=template&id=6f923a14&scoped=true"
import script from "./searchCom.vue?vue&type=script&lang=js"
export * from "./searchCom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f923a14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f923a14')) {
      api.createRecord('6f923a14', component.options)
    } else {
      api.reload('6f923a14', component.options)
    }
    module.hot.accept("./searchCom.vue?vue&type=template&id=6f923a14&scoped=true", function () {
      api.rerender('6f923a14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Problem/complaintWorkOrder/component/searchCom.vue"
export default component.exports